import { urlStoredFilter } from '../../scripts/utils/urlStoredFilter';
import { sendCustomEvent } from '../../scripts/config/analytics';
import { initSubNavObserver } from './works-with-subnav/works-with-subnav';

const DATA_OPEN_ATTR = 'data-open';
const DATA_FILTER_CONTAINER_ATTR = 'data-works-with-filter-nav';
const DATA_FILTER_LIST_BUTTON_TOGGLE_ATTR = 'data-works-with-filter-button';
const DATA_FILTER_MENU_ATTR = 'data-url-stored-filter-menu';
const DATA_FILTER_TARGET_ATTR = 'data-url-stored-filter-target';
const DATA_PRODUCTS_COUNT = 'data-products-count';

let filterTitle = null;

const initUrlStored = (initTag = '') =>
  urlStoredFilter({
    initValue: initTag,
    dataKey: 'filter',
    listeners: [setActiveFilterTitleOnClick, handleChangeFilter],
  });

initUrlStored();

const showProductsCount = () => {
  const productsCount = document.querySelectorAll(`[${DATA_PRODUCTS_COUNT}]`);
  const filters = document.querySelectorAll(`[${DATA_FILTER_MENU_ATTR}]`);
  const allProducts = document.querySelectorAll(`[${DATA_FILTER_TARGET_ATTR}]`);

  filters.forEach((filter, index) => {
    const filterValue = filter.getAttribute('data-filter') || null;

    if (filterValue) {
      const relatedProducts = Array.from(allProducts).filter((product) => {
        const productValue = product.getAttribute('data-filter');

        return productValue.includes(filterValue);
      });

      productsCount[index].textContent = relatedProducts.length.toString();
    } else {
      productsCount[index].textContent = allProducts.length.toString();
    }
  });
};

showProductsCount();

function setActiveFilterTitleOnClick(newValue) {
  const selectedFilter = document.querySelector(
    `[${DATA_FILTER_MENU_ATTR}][data-filter="${newValue}"]`
  );

  filterTitle = selectedFilter.getAttribute(DATA_FILTER_MENU_ATTR);

  const filterListToggleBtns = document.querySelectorAll(
    `[${DATA_FILTER_LIST_BUTTON_TOGGLE_ATTR}]`
  );

  filterListToggleBtns.forEach((btn) => {
    btn.innerHTML = filterTitle;
  });
}

function handleChangeFilter() {
  if (!filterTitle) return;

  sendCustomEvent({
    category: 'Works With Pages',
    action: 'Interactions With Filters: Clicks',
    label: filterTitle,
  });
}

const openFilterList = (filterListToggleBtn, filterWr) => {
  filterListToggleBtn.addEventListener('click', () => {
    const isFilterListOpen =
      filterWr.getAttribute(DATA_OPEN_ATTR) === 'true' || false;

    if (isFilterListOpen) {
      filterWr.setAttribute(DATA_OPEN_ATTR, 'false');
    } else {
      filterWr.setAttribute(DATA_OPEN_ATTR, 'true');
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest(`[${DATA_FILTER_LIST_BUTTON_TOGGLE_ATTR}]`)) {
      filterWr.setAttribute(DATA_OPEN_ATTR, 'false');
    }
    event.stopPropagation();
  });
};

const setActiveFilterTitleOnLoad = (filterListToggleBtn) => {
  const activeFilterItemEl = document.querySelector(
    `[${DATA_FILTER_MENU_ATTR}][data-active="true"]`
  );

  if (activeFilterItemEl) {
    filterListToggleBtn.innerHTML = activeFilterItemEl.getAttribute(
      DATA_FILTER_MENU_ATTR
    );
  }
};

const initCollapsibleFilter = (dataSectionValue) => {
  const section = document.querySelector(
    `[data-section="${dataSectionValue}"]`
  );
  const filterListToggleBtn = section.querySelector(
    `[${DATA_FILTER_LIST_BUTTON_TOGGLE_ATTR}]`
  );
  const filterWr = section.querySelector(`[${DATA_FILTER_CONTAINER_ATTR}]`);

  openFilterList(filterListToggleBtn, filterWr);
  setActiveFilterTitleOnLoad(filterListToggleBtn);
};

initSubNavObserver();
initCollapsibleFilter('works-with-sidebar-filters');
initCollapsibleFilter('works-with-subnav');
